import { render, staticRenderFns } from "./ModalSelectAddress.vue?vue&type=template&id=95791fa4"
import script from "./ModalSelectAddress.vue?vue&type=script&lang=js"
export * from "./ModalSelectAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports